import script from "./RadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioButton.vue?vue&type=script&setup=true&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=a20c5e5c&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a20c5e5c"]])

export default __exports__